/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type SupplyPlenumCollarType = "rectangle" | "circle";

export type HoodExhaustCollarPropertiesType = "rectangle" | "circle";

export type HoodAirchefValuesShape = "rectangle" | "circle" | "oval";

export type DiffuserCollarPropertiesType = "rectangle" | "circle";


// Branded ID types for type safety
export type ApplianceId = string & { readonly __type: 'appliance' };
export type CeilingExhaustPlenumId = string & { readonly __type: 'ceiling-exhaust-plenum' };
export type CeilingPlenumCollarId = string & { readonly __type: 'ceiling-plenum-collar' };
export type CeilingPlenumFilterId = string & { readonly __type: 'ceiling-plenum-filter' };
export type CeilingSupplyPlenumId = string & { readonly __type: 'ceiling-supply-plenum' };
export type DiffuserId = string & { readonly __type: 'diffuser' };
export type ExhaustId = string & { readonly __type: 'exhaust' };
export type GroupId = string & { readonly __type: 'group' };
export type HoodId = string & { readonly __type: 'hood' };
export type ModuleId = string & { readonly __type: 'module' };
export type ProjectId = string & { readonly __type: 'project' };
export type RoomId = string & { readonly __type: 'room' };
export type RowId = string & { readonly __type: 'row' };
export type SupplyId = string & { readonly __type: 'supply' };
export type VAVId = string & { readonly __type: 'vav' };
export type VentilatedCeilingId = string & { readonly __type: 'ceiling' };
export type ZoneId = string & { readonly __type: 'zone' };

export interface CeilingAirchefValues {
  name: string;
  /** @format int32 */
  id: number;
  description: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  "3dModel"?: null | string;
  transform: Transform;
  supplyPlenums: CeilingSupplyPlenum[];
  exhaustPlenums: CeilingExhaustPlenum[];
  /** @format double */
  maxSupplyPlenums?: null | number;
  /** @format double */
  maxExhaustPlenums?: null | number;
  configurablePlenums?: null | boolean;
  region?: Enum;
  [key: string]: any;
}

export interface CeilingExhaustPlenum {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingExhaustPlenumId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-exhaust-plenum";
  airchefValues: CeilingExhaustPlenumAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingExhaustPlenumAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  filters: CeilingPlenumFilter[];
  collars: CeilingPlenumCollar[];
  /** @format double */
  maxCollars?: null | number;
  /** @format double */
  maxFilters?: null | number;
  [key: string]: any;
}

export interface CeilingPlenumCollar {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingPlenumCollarId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-plenum-collar";
  airchefValues: CeilingPlenumCollarAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingPlenumCollarAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  [key: string]: any;
}

export interface CeilingPlenumFilter {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingPlenumFilterId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-plenum-filter";
  airchefValues: CeilingPlenumFilterAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingPlenumFilterAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  [key: string]: any;
}

export interface CeilingRelations {
  groupIds?: null | GroupId[];
  roomId?: null | RoomId;
}

export interface CeilingSupplyPlenum {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingSupplyPlenumId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-supply-plenum";
  airchefValues: CeilingSupplyPlenumAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingSupplyPlenumAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  collars: CeilingPlenumCollar[];
  /** @format double */
  maxCollars?: null | number;
  [key: string]: any;
}

export interface DatesAndAudit {
  author?: null | string;
  /** @format date-time */
  createdAt: string;
  modifiedBy?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  deletedBy?: null | string;
  /** @format date-time */
  deletedAt?: null | string;
  /** @format date-time */
  modifiedAtBySystem?: null | string;
}

export interface Diffuser {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: DiffuserId;
  schemaPath: string;
  /** @minLength 1 */
  type: "diffuser";
  airchefValues: DiffuserAirchefValues;
  haltonValues: HaltonValues;
  relations: DiffuserRelations;
}

export interface DiffuserAirchefValues {
  name: string;
  /** @format int32 */
  id: number;
  description: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  transform: Transform;
  collar?: DiffuserCollarProperties;
  region?: Enum;
  [key: string]: any;
}

export interface DiffuserCollarProperties {
  /**
   * @format int32
   * @min 1
   * @max 3
   */
  count: number;
  type: DiffuserCollarPropertiesType;
  length: LengthValue;
  width?: LengthValue;
  /**
   * @maxItems 3
   * @minItems 1
   */
  backDistance: LengthValue[];
  /**
   * @maxItems 3
   * @minItems 1
   */
  centerDistance: LengthValue[];
}

export interface DiffuserRelations {
  supplyId?: null | SupplyId;
  vavId?: null | VAVId;
  roomId?: null | RoomId;
  zoneId?: null | ZoneId;
}

export interface Enum {
  value: EnumItem;
  /** @minItems 1 */
  enum: EnumItem[];
}

export interface EnumItem {
  label: LocalisedText;
  description?: LocalisedText;
  value: string;
  [key: string]: any;
}

export interface Exhaust {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ExhaustId;
  /** @minLength 1 */
  type: "exhaust";
  schemaPath: string;
  airchefValues: ExhaustAirchefValues;
  haltonValues: HaltonValues;
  relations: ExhaustRelations;
}

export interface ExhaustAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface ExhaustRelations {
  hoodIds: HoodId[];
  zoneIds: ZoneId[];
}

export interface HaltonValues {
  /** @minLength 1 */
  type: string;
  [key: string]: any;
}

export interface Hood {
  schemaPath: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: HoodId;
  /** @minLength 1 */
  type: "hood";
  relations: HoodRelations;
  airchefValues: HoodAirchefValues;
  haltonValues: HaltonValues;
}

export interface HoodAirchefValues {
  name: string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  positionOffset?: PositionPartial;
  offsetTransform?: OffsetTransformProperties;
  "3dModel"?: null | string;
  imageThumbnail?: null | string;
  image?: null | string;
  itemNumber?: null | string;
  itemNumberOverride?: null | string;
  comment?: null | string;
  collar: HoodExhaustCollarProperties;
  hasSupplyPlenum: boolean;
  /** @maxItems 2 */
  supplyPlenum?: null | SupplyPlenum[];
  isDraft?: null | boolean;
  region?: Enum;
  canSplit?: null | boolean;
  shape?: HoodAirchefValuesShape;
  [key: string]: any;
}

export interface HoodExhaustCollarProperties {
  /**
   * @format int32
   * @min 1
   * @max 3
   */
  count: number;
  type: HoodExhaustCollarPropertiesType;
  length: LengthValue;
  width?: LengthValue;
  /**
   * @maxItems 3
   * @minItems 1
   */
  backDistance: LengthValue[];
  /**
   * @maxItems 3
   * @minItems 1
   */
  centerDistance: LengthValue[];
}

export interface HoodRelations {
  groupId?: null | GroupId;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  rowNum?: null | number;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  rowId?: null | RowId;
  roomId?: null | RoomId;
  exhaustId?: null | ExhaustId;
  zoneId?: null | ZoneId;
}

export interface LengthValue {
  /** @format double */
  value: number;
  type: "length";
  unit: string;
  unitSystem?: null | string;
}

export interface LocalisedText {
  en?: null | string;
  [key: string]: any;
}

export interface Module {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ModuleId;
  /** @minLength 1 */
  type: "module";
  schemaPath: string;
  airchefValues: ModuleAirchefValues;
  haltonValues: HaltonValues;
}

export interface ModuleAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface OffsetTransformProperties {
  position: Position;
  size: Size;
}

export interface Position {
  x: LengthValue;
  y: LengthValue;
  z: LengthValue;
}

export interface PositionPartial {
  x?: LengthValue;
  y?: LengthValue;
  z?: LengthValue;
}

export interface Rotation {
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  z: number;
}

export interface SeedingErrorsSummary {
  objectId?: string;
  errors?: ValidatorResponseError[];
}

export interface Size {
  width: LengthValue;
  length: LengthValue;
  height: LengthValue;
}

export interface Supply {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: SupplyId;
  schemaPath: string;
  /** @minLength 1 */
  type: "supply";
  airchefValues: SupplyAirchefValues;
  haltonValues: HaltonValues;
  relations: SupplyRelations;
}

export interface SupplyAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface SupplyPlenum {
  offsetTransform: OffsetTransformProperties;
  /**
   * @format int32
   * @min 1
   * @max 2
   */
  count: number;
  collarType: SupplyPlenumCollarType;
  collarLength: LengthValue;
  collarWidth: LengthValue;
  backDistance: LengthValue;
  centerDistance: LengthValue;
  [key: string]: any;
}

export interface SupplyRelations {
  zoneIds: ZoneId[];
  vavIds: VAVId[];
  diffuserIds: DiffuserId[];
  hoodIds?: null | HoodId[];
}

export interface Transform {
  position: Position;
  size: Size;
  rotation: Rotation;
}

export interface VAV {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: VAVId;
  /** @minLength 1 */
  type: "vav";
  schemaPath: string;
  airchefValues: VAVAirchefValues;
  haltonValues: HaltonValues;
  relations: VAVRelations;
}

export interface VAVAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  [key: string]: any;
}

export interface VAVRelations {
  roomId?: RoomId;
  supplyId?: null | SupplyId;
  diffuserIds?: null | DiffuserId[];
  zoneId?: null | ZoneId;
  hoodIds?: null | HoodId[];
}

export interface ValidatorResponseError {
  path?: string;
  message?: string;
  error_property?: string;
  error_schema_id?: string;
  error_schema_title?: string;
  context?: ValidatorResponseError[];
}

export interface VentilatedCeiling {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: VentilatedCeilingId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling";
  airchefValues: CeilingAirchefValues;
  haltonValues: HaltonValues;
  relations: CeilingRelations;
}

export interface CeilingsListParams {
  schemaPath?: string;
}

export type CeilingsListData = VentilatedCeiling[];

export type CeilingsCreateData = VentilatedCeiling;

export interface CeilingsDetailParams {
  id: string;
}

export type CeilingsDetailData = VentilatedCeiling;

export interface CeilingsUpdateParams {
  id: string;
}

export type CeilingsUpdateData = VentilatedCeiling;

export interface CeilingsDeleteParams {
  id: string;
}

export type CeilingsDeleteData = any;

export interface DiffusersListParams {
  schemaPath?: string;
}

export type DiffusersListData = Diffuser[];

export type DiffusersCreateData = Diffuser;

export interface DiffusersDeleteParams {
  id: string;
}

export type DiffusersDeleteData = any;

export interface ExhaustsListParams {
  schemaPath?: string;
}

export type ExhaustsListData = Exhaust[];

export type ExhaustsCreateData = Exhaust;

export interface ExhaustsDetailParams {
  id: string;
}

export type ExhaustsDetailData = Exhaust;

export interface ExhaustsUpdateParams {
  id: string;
}

export type ExhaustsUpdateData = Exhaust;

export interface ExhaustsDeleteParams {
  id: string;
}

export type ExhaustsDeleteData = any;

export interface HoodsListParams {
  schemaPath?: string;
}

export type HoodsListData = Hood[];

export type HoodsCreateData = Hood;

export interface HoodsDetailParams {
  id: string;
}

export type HoodsDetailData = Hood;

export interface HoodsUpdateParams {
  id: string;
}

export type HoodsUpdateData = Hood;

export interface HoodsDeleteParams {
  id: string;
}

export type HoodsDeleteData = any;

export interface ModulesListParams {
  schemaPath?: string;
}

export type ModulesListData = Module[];

export type ModulesCreateData = Module;

export interface ModulesDetailParams {
  id: string;
}

export type ModulesDetailData = Module;

export interface ModulesUpdateParams {
  id: string;
}

export type ModulesUpdateData = Module;

export interface ModulesDeleteParams {
  id: string;
}

export type ModulesDeleteData = any;

export interface ReseedCreateParams {
  type?: string;
  surely?: string;
}

export type ReseedCreateData = SeedingErrorsSummary[];

export interface SchemadataListParams {
  schemaPath?: string;
}

export type SchemadataListData = any;

export type SchemadataCreatePayload = any;

export type SchemadataCreateData = any;

export interface SuppliesListParams {
  schemaPath?: string;
}

export type SuppliesListData = Supply[];

export type SuppliesCreateData = Supply;

export interface SuppliesDetailParams {
  id: string;
}

export type SuppliesDetailData = Supply;

export interface SuppliesUpdateParams {
  id: string;
}

export type SuppliesUpdateData = Supply;

export interface SuppliesDeleteParams {
  id: string;
}

export type SuppliesDeleteData = any;

export interface VavsListParams {
  schemaPath?: string;
}

export type VavsListData = VAV[];

export type VavsCreateData = VAV;

export interface VavsDetailParams {
  id: string;
}

export type VavsDetailData = VAV;

export interface VavsUpdateParams {
  id: string;
}

export type VavsUpdateData = VAV;

export interface VavsDeleteParams {
  id: string;
}

export type VavsDeleteData = any;

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === "multipart/form-data" &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === "text/plain" &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title PIM.API
 * @version 1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  ceiling = {
    /**
     * No description
     *
     * @tags Ceiling
     * @name CeilingsList
     * @request GET:/ceilings
     * @secure
     */
    ceilingsList: (
      query: CeilingsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CeilingsListData, any>({
        path: `/ceilings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ceiling
     * @name CeilingsCreate
     * @request POST:/ceilings
     * @secure
     */
    ceilingsCreate: (data: VentilatedCeiling, params: RequestParams = {}) =>
      this.request<CeilingsCreateData, any>({
        path: `/ceilings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ceiling
     * @name CeilingsDetail
     * @request GET:/ceilings/{id}
     * @secure
     */
    ceilingsDetail: (
      { id }: CeilingsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<CeilingsDetailData, any>({
        path: `/ceilings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ceiling
     * @name CeilingsUpdate
     * @request PUT:/ceilings/{id}
     * @secure
     */
    ceilingsUpdate: (
      { id }: CeilingsUpdateParams,
      data: VentilatedCeiling,
      params: RequestParams = {},
    ) =>
      this.request<CeilingsUpdateData, any>({
        path: `/ceilings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ceiling
     * @name CeilingsDelete
     * @request DELETE:/ceilings/{id}
     * @secure
     */
    ceilingsDelete: (
      { id }: CeilingsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<CeilingsDeleteData, any>({
        path: `/ceilings/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  diffuser = {
    /**
     * No description
     *
     * @tags Diffuser
     * @name DiffusersList
     * @request GET:/diffusers
     * @secure
     */
    diffusersList: (
      query: DiffusersListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DiffusersListData, any>({
        path: `/diffusers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diffuser
     * @name DiffusersCreate
     * @request POST:/diffusers
     * @secure
     */
    diffusersCreate: (data: Diffuser, params: RequestParams = {}) =>
      this.request<DiffusersCreateData, any>({
        path: `/diffusers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diffuser
     * @name DiffusersDelete
     * @request DELETE:/diffusers/{id}
     * @secure
     */
    diffusersDelete: (
      { id }: DiffusersDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DiffusersDeleteData, any>({
        path: `/diffusers/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  exhaust = {
    /**
     * No description
     *
     * @tags Exhaust
     * @name ExhaustsList
     * @request GET:/exhausts
     * @secure
     */
    exhaustsList: (
      query: ExhaustsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ExhaustsListData, any>({
        path: `/exhausts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exhaust
     * @name ExhaustsCreate
     * @request POST:/exhausts
     * @secure
     */
    exhaustsCreate: (data: Exhaust, params: RequestParams = {}) =>
      this.request<ExhaustsCreateData, any>({
        path: `/exhausts`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exhaust
     * @name ExhaustsDetail
     * @request GET:/exhausts/{id}
     * @secure
     */
    exhaustsDetail: (
      { id }: ExhaustsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ExhaustsDetailData, any>({
        path: `/exhausts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exhaust
     * @name ExhaustsUpdate
     * @request PUT:/exhausts/{id}
     * @secure
     */
    exhaustsUpdate: (
      { id }: ExhaustsUpdateParams,
      data: Exhaust,
      params: RequestParams = {},
    ) =>
      this.request<ExhaustsUpdateData, any>({
        path: `/exhausts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exhaust
     * @name ExhaustsDelete
     * @request DELETE:/exhausts/{id}
     * @secure
     */
    exhaustsDelete: (
      { id }: ExhaustsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ExhaustsDeleteData, any>({
        path: `/exhausts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  hood = {
    /**
     * No description
     *
     * @tags Hood
     * @name HoodsList
     * @request GET:/hoods
     * @secure
     */
    hoodsList: (query: HoodsListParams = {}, params: RequestParams = {}) =>
      this.request<HoodsListData, any>({
        path: `/hoods`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hood
     * @name HoodsCreate
     * @request POST:/hoods
     * @secure
     */
    hoodsCreate: (data: Hood, params: RequestParams = {}) =>
      this.request<HoodsCreateData, any>({
        path: `/hoods`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hood
     * @name HoodsDetail
     * @request GET:/hoods/{id}
     * @secure
     */
    hoodsDetail: ({ id }: HoodsDetailParams, params: RequestParams = {}) =>
      this.request<HoodsDetailData, any>({
        path: `/hoods/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hood
     * @name HoodsUpdate
     * @request PUT:/hoods/{id}
     * @secure
     */
    hoodsUpdate: (
      { id }: HoodsUpdateParams,
      data: Hood,
      params: RequestParams = {},
    ) =>
      this.request<HoodsUpdateData, any>({
        path: `/hoods/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Hood
     * @name HoodsDelete
     * @request DELETE:/hoods/{id}
     * @secure
     */
    hoodsDelete: ({ id }: HoodsDeleteParams, params: RequestParams = {}) =>
      this.request<HoodsDeleteData, any>({
        path: `/hoods/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  module = {
    /**
     * No description
     *
     * @tags Module
     * @name ModulesList
     * @request GET:/modules
     * @secure
     */
    modulesList: (query: ModulesListParams = {}, params: RequestParams = {}) =>
      this.request<ModulesListData, any>({
        path: `/modules`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Module
     * @name ModulesCreate
     * @request POST:/modules
     * @secure
     */
    modulesCreate: (data: Module, params: RequestParams = {}) =>
      this.request<ModulesCreateData, any>({
        path: `/modules`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Module
     * @name ModulesDetail
     * @request GET:/modules/{id}
     * @secure
     */
    modulesDetail: ({ id }: ModulesDetailParams, params: RequestParams = {}) =>
      this.request<ModulesDetailData, any>({
        path: `/modules/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Module
     * @name ModulesUpdate
     * @request PUT:/modules/{id}
     * @secure
     */
    modulesUpdate: (
      { id }: ModulesUpdateParams,
      data: Module,
      params: RequestParams = {},
    ) =>
      this.request<ModulesUpdateData, any>({
        path: `/modules/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Module
     * @name ModulesDelete
     * @request DELETE:/modules/{id}
     * @secure
     */
    modulesDelete: ({ id }: ModulesDeleteParams, params: RequestParams = {}) =>
      this.request<ModulesDeleteData, any>({
        path: `/modules/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  reseed = {
    /**
     * No description
     *
     * @tags Reseed
     * @name ReseedCreate
     * @request POST:/reseed
     * @secure
     */
    reseedCreate: (
      query: ReseedCreateParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ReseedCreateData, any>({
        path: `/reseed`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  schemaData = {
    /**
     * No description
     *
     * @tags SchemaData
     * @name SchemadataList
     * @request GET:/schemadata
     * @secure
     */
    schemadataList: (
      query: SchemadataListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SchemadataListData, any>({
        path: `/schemadata`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SchemaData
     * @name SchemadataCreate
     * @request POST:/schemadata
     * @secure
     */
    schemadataCreate: (
      data: SchemadataCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<SchemadataCreateData, any>({
        path: `/schemadata`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  supply = {
    /**
     * No description
     *
     * @tags Supply
     * @name SuppliesList
     * @request GET:/supplies
     * @secure
     */
    suppliesList: (
      query: SuppliesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SuppliesListData, any>({
        path: `/supplies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supply
     * @name SuppliesCreate
     * @request POST:/supplies
     * @secure
     */
    suppliesCreate: (data: Supply, params: RequestParams = {}) =>
      this.request<SuppliesCreateData, any>({
        path: `/supplies`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supply
     * @name SuppliesDetail
     * @request GET:/supplies/{id}
     * @secure
     */
    suppliesDetail: (
      { id }: SuppliesDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<SuppliesDetailData, any>({
        path: `/supplies/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supply
     * @name SuppliesUpdate
     * @request PUT:/supplies/{id}
     * @secure
     */
    suppliesUpdate: (
      { id }: SuppliesUpdateParams,
      data: Supply,
      params: RequestParams = {},
    ) =>
      this.request<SuppliesUpdateData, any>({
        path: `/supplies/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supply
     * @name SuppliesDelete
     * @request DELETE:/supplies/{id}
     * @secure
     */
    suppliesDelete: (
      { id }: SuppliesDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<SuppliesDeleteData, any>({
        path: `/supplies/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  vav = {
    /**
     * No description
     *
     * @tags Vav
     * @name VavsList
     * @request GET:/vavs
     * @secure
     */
    vavsList: (query: VavsListParams = {}, params: RequestParams = {}) =>
      this.request<VavsListData, any>({
        path: `/vavs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vav
     * @name VavsCreate
     * @request POST:/vavs
     * @secure
     */
    vavsCreate: (data: VAV, params: RequestParams = {}) =>
      this.request<VavsCreateData, any>({
        path: `/vavs`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vav
     * @name VavsDetail
     * @request GET:/vavs/{id}
     * @secure
     */
    vavsDetail: ({ id }: VavsDetailParams, params: RequestParams = {}) =>
      this.request<VavsDetailData, any>({
        path: `/vavs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vav
     * @name VavsUpdate
     * @request PUT:/vavs/{id}
     * @secure
     */
    vavsUpdate: (
      { id }: VavsUpdateParams,
      data: VAV,
      params: RequestParams = {},
    ) =>
      this.request<VavsUpdateData, any>({
        path: `/vavs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vav
     * @name VavsDelete
     * @request DELETE:/vavs/{id}
     * @secure
     */
    vavsDelete: ({ id }: VavsDeleteParams, params: RequestParams = {}) =>
      this.request<VavsDeleteData, any>({
        path: `/vavs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
